var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 104.217,
    y1: 476,
    x2: 104.217,
    y2: 53.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#a163f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#b074ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#d8a1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#efbad3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 104.108,
    y1: 476,
    x2: 104.108,
    y2: 53.034,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 255.858,
    y1: 476,
    x2: 255.858,
    y2: 53.034,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 418.519,
    y1: 476,
    x2: 418.519,
    y2: 53.034,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 279.506,
    y1: 476,
    x2: 279.506,
    y2: 53.034,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 99.084,
    y1: 476,
    x2: 99.084,
    y2: 53.034,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 163.221,
    y1: 476,
    x2: 163.221,
    y2: 53.034,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.217,349.422a66.658,66.658,0,1,0,66.657,66.658A66.733,66.733,0,0,0,104.217,349.422Zm0,121.315a54.658,54.658,0,1,1,54.657-54.657A54.719,54.719,0,0,1,104.217,470.737Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.217,394.428a7.679,7.679,0,0,1,7.67,7.671,6,6,0,0,0,6,6,5.909,5.909,0,0,0,5.891-6A19.694,19.694,0,0,0,110,383.372v-2.455a6,6,0,0,0-12,0v2.455A19.5,19.5,0,0,0,84.438,402.1a19.739,19.739,0,0,0,19.724,19.67A7.668,7.668,0,0,1,104.3,437.1c-.032,0-.058,0-.09,0s-.062,0-.093,0a7.675,7.675,0,0,1-7.572-7.665,6,6,0,0,0-6-6,6.093,6.093,0,0,0-6.108,6A19.5,19.5,0,0,0,98,448.165v3.077a6,6,0,0,0,12,0v-3.077a19.646,19.646,0,0,0-5.838-38.4,7.671,7.671,0,0,1,.055-15.341Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,284.146v-47.6A35.558,35.558,0,0,0,431.7,201H421V109.709a6.11,6.11,0,0,0-2.494-4.786,5.625,5.625,0,0,0-5.076-.986L381,113.178V31.658A27.057,27.057,0,0,0,353.605,5l-148.8,2.155a26.732,26.732,0,0,0-25.645,21.223A26.744,26.744,0,0,0,158,54.472v122.01L75.727,201.247l-.155.249A6.21,6.21,0,0,0,71,207.259V330.822A91.489,91.489,0,1,0,170.587,479H431.7c19.455,0,35.3-16.2,35.3-35.653v-47.6a35.408,35.408,0,0,0,32-35.1V319.25A35.408,35.408,0,0,0,467,284.146Zm-86-158.5,28-8V201H381ZM190,33.814a14.928,14.928,0,0,1,14.685-14.657L353.543,17a15.3,15.3,0,0,1,10.8,4.216A14.847,14.847,0,0,1,369,31.658V201h-9V54.463a6.129,6.129,0,0,0-1.822-4.177L336.423,27.873A6.2,6.2,0,0,0,332.052,26H226.271a6.048,6.048,0,0,0-4.308,1.875l-21.137,21.7a6.19,6.19,0,0,0-1.826,4.2V201h-9Zm89.506,74.276a66.982,66.982,0,0,0-67.017,66.886A65.51,65.51,0,0,0,217.8,201H211V56.205L228.812,38h100.7L348,56.9V201h-6.788a65.526,65.526,0,0,0,5.31-26.024A66.981,66.981,0,0,0,279.506,108.09Zm55.016,66.854A54.524,54.524,0,0,1,327.914,201H231.1a54.4,54.4,0,0,1-6.609-26.024,55.017,55.017,0,0,1,110.033-.032ZM170,54.472c0-5.908,3-11.043,8-13.354V201h-8ZM158,189.014V201H117.185Zm6.419,278.743-2.151-2.131a6.005,6.005,0,0,0-8.485,8.5l2.042,2.154A77.74,77.74,0,0,1,110,495.253v-3.076a6,6,0,0,0-12,0v3.076a79.832,79.832,0,0,1-45.609-18.971l2.2-2.151a5.985,5.985,0,1,0-8.444-8.485l-2.144,2.112A80.266,80.266,0,0,1,25.043,422h3.076a6,6,0,1,0,0-12H25.043a80.029,80.029,0,0,1,18.972-45.678l2.151,2.172a5.993,5.993,0,1,0,8.484-8.468l-2.259-2.15A79.83,79.83,0,0,1,98,336.906v3.076a6,6,0,0,0,12,0v-3.076a77.732,77.732,0,0,1,45.825,18.971l-2.1,2.151a6.017,6.017,0,0,0,8.532,8.486l2.155-2.191A80.049,80.049,0,0,1,183.39,410h-3.077a6,6,0,0,0,0,12h3.077A80.274,80.274,0,0,1,164.419,467.757ZM455,443.347C455,456.185,444.541,467,431.7,467H180.2A91.494,91.494,0,0,0,83,327.068V213H431.7A23.545,23.545,0,0,1,455,236.542V284H400.486A35.468,35.468,0,0,0,365,319.25v41.389A35.564,35.564,0,0,0,400.486,396H455Zm32-82.63A23.283,23.283,0,0,1,463.717,384H400.283A23.283,23.283,0,0,1,377,360.717V319.283A23.283,23.283,0,0,1,400.283,296h63.434A23.283,23.283,0,0,1,487,319.283Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.345,319h-5.651c-11.382,0-20.641,9.618-20.641,21s9.259,21,20.641,21h5.651c11.381,0,20.64-9.618,20.64-21S432.726,319,421.345,319Zm0,30h-5.651a9.007,9.007,0,0,1,0-18h5.651a9.007,9.007,0,0,1,0,18Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.108,169H311.76a19.178,19.178,0,0,0-18.5-13.4,19.5,19.5,0,0,0-19.453,19.479,7.45,7.45,0,0,1-14.9.117c0-.033,0-.061,0-.093s0-.063,0-.095a7.458,7.458,0,0,1,7.447-7.356,6.026,6.026,0,0,0,0-12.052A19.179,19.179,0,0,0,247.864,169H244.9a6,6,0,0,0,0,12h2.961a19.438,19.438,0,0,0,37.948-5.921,7.453,7.453,0,1,1,7.453,7.476,5.975,5.975,0,1,0,0,11.949,19.27,19.27,0,0,0,18.5-13.5h2.348a6,6,0,0,0,0-12Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.506,42.4a27.062,27.062,0,1,0,27.062,27.062A27.094,27.094,0,0,0,279.506,42.4Zm0,42.124a15.062,15.062,0,1,1,15.062-15.062A15.08,15.08,0,0,1,279.506,84.527Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.577,233H97.592a6,6,0,1,0,0,12h2.985a6,6,0,0,0,0-12Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.555,233H119.887a6,6,0,0,0,0,12h86.668a6,6,0,0,0,0-12Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3224f75b1e1bb0e24d99e0838404405c.svg";
export { ForwardRef as ReactComponent };